// extracted by css-extract-rspack-plugin
var _1 = "uKeT9ubZiE8RgtgQ";
var _2 = "N5jRRL9tnskhgZO7";
export { _1 as "disabled", _2 as "tab" }
